
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 117.6 167.7","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M73.4 71.7V119c0 11.2-8 18-18.5 18-24.3 0-24.3-35 0-35h6.5V72.3h-6c-16.4 0-16-21.5-.4-21.5 7.9 0 11.7 3 11.7 8.1h32c.4-7.9-1.2-14.5-4.4-19.9C96.4 25 92.1 10.8 82.6.4c-.5-.5-1.3-.5-1.8 0L77 3.6c-4.8 3.8-10 7.2-15.4 10.1-.6.4-1.3.6-2 .5-3.7-.4-7.4-.2-11 .4-3.2.5-6.3 1.4-9.3 2.8-.7.4-1.5.4-2.3.2-10.3-2.9-21.1-3.2-31.5-.8-.2 0-.3.2-.2.4.8 15.7 4.7 23.2 7.3 26.6-6.5 13.6-4.1 29.8 6 41C-15.2 109.3-3 167.7 55 167.7c30.8 0 50-17 50-48.7v-15.8h12.6V71.7z","fill":"#35C5A5"}})])
          )
        }
      }
    